class MainProductImages extends HTMLElement {
  connectedCallback() {
    const mainImage = this.querySelector("[data-main-image]");
    const images = this.querySelectorAll("[data-images] img");

    images.forEach((img, index) => {
      const wrapper = img.parentElement;

      if (index === 0) {
        wrapper.classList.add("border-2", "border-[#9DB464]");
      } else {
        wrapper.classList.add("border-2", "border-[#c9e681]");
      }

      img.addEventListener("click", () => {
        mainImage.src = img.src;

        images.forEach((i) => {
          const w = i.parentElement;
          w.classList.remove("border-[#9DB464]");
          w.classList.add("border-[#c9e681]");
        });

        wrapper.classList.remove("border-[#c9e681]");
        wrapper.classList.add("border-[#9DB464]");
      });
    });
  }
}

customElements.define("main-product-images", MainProductImages);

class QuantitySelector extends HTMLElement {
  connectedCallback() {
    const decrease = this.querySelector("#decrease-quantity");
    const increase = this.querySelector("#increase-quantity");
    const input = this.querySelector("#quantity");

    decrease.addEventListener("click", () => {
      const val = parseInt(input.value, 10);
      if (!isNaN(val) && val > 1) input.value = val - 1;
    });

    increase.addEventListener("click", () => {
      const val = parseInt(input.value, 10);
      const max = parseInt(input.max, 10);
      if (!isNaN(val) && val + 1 <= max) input.value = val + 1;
    });
  }
}

class ProductForm extends HTMLElement {
  connectedCallback() {
    this.#form.addEventListener("submit", (e) => {
      e.preventDefault();
      this.#handleSubmit();
    });
  }

  get #form() {
    return this.querySelector("form");
  }
  get #submitButton() {
    return this.querySelector("#submit-product-button");
  }
  get #errorContainer() {
    return this.querySelector("#error-message");
  }
  get #errorIcon() {
    return this.querySelector("#ErrorImage");
  }

  async #handleSubmit() {
    const btn = this.#submitButton;
    btn.textContent = "Cargando...";
    btn.disabled = true;

    const formData = Object.fromEntries(new FormData(this.#form));
    const body = {
      items: [formData],
      sections: "header",
      sections_url: location.pathname,
    };

    try {
      const response = await fetch(`/cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      }).then((r) => r.json());

      if (response.status) {
        this.#showError(response.description);
        btn.textContent = "Parece que hubo un error";
        btn.style.borderColor = "#b46464";
        btn.style.color = "#b46464";
        setTimeout(() => this.#resetButton(), 1200);
        return;
      }

      if (response.sections) {
        for (const [key, value] of Object.entries(response.sections)) {
          const el = document.getElementById(key);
          if (el) el.parentElement.innerHTML = value;
          else console.error(`Element #${key} not found`);
        }
      }

      btn.textContent = "¡Agregado con éxito!";
      btn.style.borderColor = "#9DB464";
      btn.style.color = "#9DB464";
      setTimeout(() => this.#resetButton(), 1200);
    } catch (error) {
      console.error("Error:", error);
      this.#resetButton();
    }
  }

  #showError(message) {
    const container = this.#errorContainer;
    const icon = this.#errorIcon;
    container.querySelector("p").textContent = message;
    container.classList.remove("hidden");
    icon.classList.remove("hidden");
  }

  #resetButton() {
    const btn = this.#submitButton;
    btn.textContent = "Agregar al Carrito";
    btn.style.borderColor = "#9DB464";
    btn.style.color = "#9DB464";
    btn.disabled = false;
    this.#errorContainer.classList.add("hidden");
    this.#errorIcon.classList.add("hidden");
  }
}

customElements.define("quantity-selector", QuantitySelector);
customElements.define("product-form", ProductForm);

document.addEventListener("DOMContentLoaded", function () {
  const select = document.getElementById("variant-select");

  if (!select) return;

  select.addEventListener("change", (e) => {
    const url = e.target.value;
    if (url) {
      window.location.href = url;
    }
  });
});
